import { Typography } from '@portals/core/src/components/Typography/Typography';
import { AvatarCard } from '@portals/core/src/containers/AvatarCard/AvatarCard';
import { slugify } from '@portals/core/src/utilities/slugify';
import { trackAvatar } from '@portals/tracking/src/content/trackAvatar';
import { TrackingContext } from '@portals/tracking/src/context/tracking';
import Image from 'next/image';
import React, { useCallback } from 'react';

import { ContentAvatar as AvatarModel } from '../../../models';

export interface Props {
  node: AvatarModel;
  actions: JSX.Element[];
  id: string;
}

export const Avatar: React.FC<Props> = ({ node, actions, id }: Props) => {
  const handleTracking = useCallback(
    (payload) => {
      trackAvatar({
        id: node.id,
        headline: node.headline?.[0]?.text,
        ...payload,
      });
    },
    [node.headline, node.id]
  );

  return (
    <TrackingContext.Provider value={{ trackLink: handleTracking }}>
      <AvatarCard
        id={slugify(id)}
        imageComponent={
          <Image
            src={node.image?.url}
            alt={node.image?.alternativeText}
            width={120}
            height={120}
            style={{
              objectFit: 'cover',
              width: '100%',
              height: 'auto',
            }}
          />
        }
        actions={actions}
        headline={
          <Typography variant="h6" innerPadding="horizontal" color="text.overline" marginBottom={4}>
            {node.headline?.[0]?.text}
          </Typography>
        }
        text={
          <Typography variant="h3" innerPadding="horizontal">
            {node.text}
          </Typography>
        }
        subline={
          <Typography variant="body2" color="text.secondary" innerPadding="horizontal">
            {node.subline}
          </Typography>
        }
      />
    </TrackingContext.Provider>
  );
};
